import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import DictionaryCtx from "../../../../../contexts/DictionaryCtx";
import LineTemplate from "./Line";
import SelectTemplate from "./Select";
import CheckboxTemplate from "./Checkbox";
import LineWithColorPickerTemplate from "./LineWithColorPicker";
import getFormattedPriceMapForVariant from "../../../services/lib/price-map-formatter";

export default class Template extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    variant: PropTypes.object,
    productMeta: PropTypes.object,
    colorHexMap: PropTypes.object,
    currentVariants: PropTypes.object,
    changeVariant: PropTypes.func,
    withoutTitle: PropTypes.bool
  };
  render() {
    const {
      name,
      variant,
      productMeta,
      currentVariants,
      changeVariant,
      colorHexMap,
      withoutTitle
    } = this.props;
    return (
      <DictionaryCtx.Consumer>
        {(dict) => {
          switch (name) {
            case `Line`:
              return (
                <LineTemplate
                  variant={variant.name}
                  title={withoutTitle ? `` : variant.title}
                  subTitle={variant.subTitle}
                  currentValue={currentVariants[variant.name]}
                  items={productMeta[variant.keyInProductMeta]}
                  itemsMap={
                    variant.name === `color` || variant.name === `mug_color`
                      ? colorHexMap
                      : void 0
                  }
                  changeVariant={changeVariant}
                  customHandleClick={variant.handleClick}
                  description={variant.description}
                  priceMap={
                    variant.withPrice
                      ? getFormattedPriceMapForVariant(
                          productMeta.price_data,
                          variant.name
                        )
                      : void 0
                  }
                  filterOfItemsBy={variant.filterOfItemsBy}
                  dict={dict}
                />
              );

            case `Select`:
              return (
                <SelectTemplate
                  variant={variant.name}
                  title={withoutTitle ? `` : variant.title}
                  currentValue={currentVariants[variant.name]}
                  items={productMeta[variant.keyInProductMeta]}
                  changeVariant={changeVariant}
                  customHandleClick={variant.handleClick}
                  description={variant.description}
                  priceMap={
                    variant.withPrice
                      ? getFormattedPriceMapForVariant(
                          productMeta.price_data,
                          variant.name
                        )
                      : void 0
                  }
                  dict={dict}
                />
              );

            case `Checkbox`:
              return (
                <CheckboxTemplate
                  variant={variant.name}
                  title={withoutTitle ? `` : variant.title}
                  currentValue={currentVariants[variant.name]}
                  items={productMeta[variant.keyInProductMeta]}
                  changeVariant={changeVariant}
                  customHandleClick={variant.handleClick}
                  description={variant.description}
                  priceMap={
                    variant.withPrice
                      ? getFormattedPriceMapForVariant(
                          productMeta.price_data,
                          variant.name
                        )
                      : void 0
                  }
                  dict={dict}
                />
              );

            case `LineWithColorPicker`:
              return (
                <LineWithColorPickerTemplate
                  variant={variant.name}
                  title={withoutTitle ? `` : variant.title}
                  items={variant.colors}
                  changeVariant={changeVariant}
                />
              );
          }
          return void 0;
        }}
      </DictionaryCtx.Consumer>
    );
  }
}
